import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { IAuthContext } from 'models/common';

interface IProps {
	context: IAuthContext;
	t?: (key: string) => string;
	register?: boolean;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class LoginComponent extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	private handleOnLogoutClick(e, logout) {
		e.preventDefault();
		logout();
	}

	private handleOnLoginClick(e, signinRedirect) {
		e.preventDefault();
		signinRedirect();
	}

	private handleOnRegisterClick(e, signinRedirectJoin) {
		e.preventDefault();
		signinRedirectJoin();
	}

	public render() {
		const { t, register } = this.props;
		const { isAuthenticated, signinRedirect, logout, signinRedirectJoin } = this.props.context;

		return (
			<>
				{isAuthenticated() ? (
					<a href="#" onClick={(e) => this.handleOnLogoutClick(e, logout)}>
						{t('Navigation_Main_UserMenu_Logout')}
					</a>
				) : register ? (
					<a href="#" onClick={(e) => this.handleOnRegisterClick(e, signinRedirectJoin)}>
						{t('Navigation_Main_UserMenu_Register')}
					</a>
				) : (
					<a href="#" onClick={(e) => this.handleOnLoginClick(e, signinRedirect)}>
						{t('Navigation_Main_UserMenu_Login')}
					</a>
				)}
			</>
		);
	}
}
const Login = withAuthContext(LoginComponent);

export { Login };
